/* eslint-disable max-classes-per-file */
export interface RequestPreAllocateTour {
  tourPeriodId?: string;
}

export class PreAllocateTourInterface {
  tourId: number;

  tourPeriodId: number;

  tourCode: string;

  tourName: string;

  tourSlug: string;

  tourPhoto: string;

  tourRange: {
    days: number;
    nights: number;
  };

  hotelStarRating: number;

  tourInspirations: Array<{
    id: number;
    name: string;
    slug: string;
    inspirationType: string;
  }>;

  destinations: {
    citySlug: string;
    countrySlug: string;
  };

  airline: {
    name: string;
    slug: string;
    id: number;
    code: string;
    logo: string;
  };

  prices: {
    name: string;
    price: number;
    originalPrice: number;
  }[];

  currency: string;

  travellingFromDate: string;

  travellingToDate: string;

  key: string;

  constructor(res: any) {
    this.tourId = res?.tourId || 0;
    this.tourPeriodId = res?.tourPeriodId || 0;
    this.tourCode = res?.tourCode || "";
    this.tourName = res?.tourName || "";
    this.tourSlug = res?.tourSlug || "";
    this.tourPhoto = res?.tourPhoto || "";
    this.tourRange = res?.tourRange || {
      days: 0,
      nights: 0,
    };
    this.hotelStarRating = res?.hotelStarRating || 0;
    this.tourInspirations = res?.tourInspirations || [];
    this.destinations = res?.destinations || {
      citySlug: "",
      countrySlug: "",
    };
    this.airline = res?.airline || {
      name: "",
      slug: "",
      id: 0,
      code: "",
      logo: "",
    };
    this.prices = res?.prices || [];
    this.currency = res?.currency || "";
    this.travellingFromDate = res?.travellingFromDate || "";
    this.travellingToDate = res?.travellingToDate || "";
    this.key = res?.key || "";
  }
}

export class ResponsePreAllocateTour {
  status: boolean;

  message: string;

  data: PreAllocateTourInterface;

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = new PreAllocateTourInterface(res?.data);
  }
}
